import HighlightsBox from './HighlightsBox'
export default HighlightsBox
